import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=99048de4&scoped=true"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&id=99048de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99048de4",
  null
  
)

export default component.exports